import $ from 'jquery';


const isRtl = document.documentElement.lang === 'ar';
const heroCarousel = () => {
  $('[data-js="js-slider"]').slick({
    // fade: true,
    pauseOnHover: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    mobileFirst: true,
    prevArrow: $('.slide-left'),
    nextArrow: $('.slide-right'),
    rtl: isRtl
  });

  const countDown = (date, container) => {
    const countDownDate = new Date(date).getTime();
    const x = setInterval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      container.find('.js-countdown-days .countdown__item--number').text(days);
      container.find('.js-countdown-hours .countdown__item--number').text(hours);
      container.find('.js-countdown-minutes .countdown__item--number').text(minutes);
      container.find('.js-countdown-seconds .countdown__item--number').text(seconds);

      if (distance < 0) {
        clearInterval(x);
        container.find('.countdown__item--number:not(.countdown__separator)').text(0);
      }
    }, 1000);
  };

  $('input[data-js="countdown_date"]').each(function () {
    const dateUTC = $(this).attr('value') + ' UTC';
    const container = $(this).siblings('.js-countdown');
    countDown(dateUTC, container);
  });
};

export default () => {
  heroCarousel();
};
